import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {ArkivmappeMenyKomponent} from "web-ng2/moduler/arkiv/komponenter/arkivmappe-meny/arkivmappe-meny";
import {MatIconButton} from "@angular/material/button";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MatMenuTrigger} from "@angular/material/menu";
import {TranslateModule} from "@ngx-translate/core";
import {DelegerteMappevisningOperasjoner, DelegerteMappevisningOperasjoner_DI_TOKEN, MappevisningBasisKomponent} from "web-ng2/moduler/arkiv/komponenter/mappevisning/MappevisningBasisKomponent";

const debug = initDebugger('ArkivmappeKortvisningKomponent');

/**
 * Visning av arkivmappe for bruk i kort-visning.
 */
@Component({
    selector: 'arkivmappe-kortvisning',
    templateUrl: 'arkivmappe-kortvisning.html',
    styleUrl: 'arkivmappe-kortvisning.scss',
    host: {'data-testid': 'mappe'},
    imports: [
        MatIcon,
        MatTooltip,
        HtmlFormatertKomponent,
        ArkivmappeMenyKomponent,
        MatIconButton,
        MatMenuTrigger,
        TranslateModule,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArkivmappeKortvisningKomponent extends MappevisningBasisKomponent {

    constructor(@Inject(DelegerteMappevisningOperasjoner_DI_TOKEN) delegerteOperasjoner: DelegerteMappevisningOperasjoner, kontekst: BrukerkontekstTilbyder) {
        super(delegerteOperasjoner, kontekst);
    }
}
